import connectedStore from 'yola-editor/src/js/store/connected-store';
import selectors from '../selectors';

const getUserFeatures = () => connectedStore.applySelector(selectors.getUserFeatures);

export default getUserFeatures;
